import { useEffect, useState } from 'react';

/**
 * Returns a value that trails the input by `delayMs`: it only updates after the
 * input has been stable for that long. Use to decouple rapid state changes
 * (e.g. toggling several filter checkboxes) from expensive consumers (e.g. a
 * TanStack Query key change firing a backend request per toggle).
 */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    if (Object.is(debounced, value)) {
      return;
    }
    const timeoutId = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timeoutId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value, delayMs]);

  return debounced;
}
